import React from 'react';
import { motion } from 'framer-motion';
const BANNER_URL = 'https://cdn.magicpatterns.com/uploads/nx54wsSuG2rY32PeywPCQ9/banner_mas_logo_perlado.png';
export function Hero() {
  return <section className="relative flex flex-col items-center pb-10 overflow-hidden bg-rotterdam-black pt-24" data-id="element-137">
      {/* Headline and CTA section */}
      <div className="max-w-4xl mx-auto text-center z-10 w-full px-6" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} data-id="element-139">
          <h1 className="text-3xl sm:text-5xl md:text-7xl font-serif font-bold leading-tight mb-6" data-id="element-140">
            Por fin una barbería en Rosario que te corta como pedís{' '}
            <br className="hidden md:block" data-id="element-141" />
            <span className="text-rotterdam-gold pearl-text italic font-normal" data-id="element-142">
              — no como ellos quieren
            </span>
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="text-rotterdam-gray text-sm sm:text-lg md:text-xl mb-8 mx-auto font-light tracking-wide" data-id="element-143">
          Cortes old school · Afeitado tradicional · Barra de tragos · Servicio
          para novios
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-144">
          <motion.a href="https://www.instagram.com/rotterdam_rosario?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" animate={{
          scale: [1, 1.03, 1]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1.5
        }} className="w-full sm:w-auto px-8 py-4 bg-[#00E5FF] text-rotterdam-black font-bold uppercase tracking-wide rounded-full shadow-[0_0_15px_rgba(0,229,255,0.6)] hover:shadow-[0_0_25px_rgba(0,255,213,0.8)] transition-all duration-300 animate-pulse" data-id="element-145">
            Conocé Rotterdam
          </motion.a>
        </motion.div>
      </div>

      {/* About section: text + divider + salon photo */}
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 1
    }} className="max-w-5xl mx-auto w-full px-6 mt-16 flex flex-col md:flex-row items-stretch gap-0" data-id="element-146">
        {/* Text side */}
        <div className="flex-1 pr-0 md:pr-10 flex flex-col justify-center text-left" data-id="element-147">
          <p className="text-rotterdam-gold pearl-text text-xs font-bold tracking-widest uppercase mb-3" data-id="element-148">
            De Rotterdam Barbería Rosario
          </p>
          <h3 className="text-2xl md:text-3xl font-serif font-bold mb-5 leading-snug" data-id="element-149">
            Descubrí la Elegancia Clásica y la Distinción Moderna
          </h3>
          <p className="text-rotterdam-cream/80 text-sm md:text-base leading-relaxed" data-id="element-150">
            En nuestro espacio fusionamos la maestría de los cortes clásicos con
            un toque de modernidad. Cada corte y estilo es una creación
            meticulosa, diseñada para realzar tu personalidad y autenticidad.
          </p>
          <p className="text-rotterdam-cream/80 text-sm md:text-base leading-relaxed mt-4" data-id="element-151">
            Queremos que tu tiempo con nosotros sea una experiencia completa. Te
            ofrecemos la oportunidad de relajarte y socializar en nuestro social
            club — mientras esperás tu turno o después del mismo, podés
            disfrutar de un cóctel 🍸.
          </p>
          <p className="text-rotterdam-cream/80 text-sm md:text-base leading-relaxed mt-4" data-id="element-152">
            Este es el lugar donde el estilo y la camaradería se encuentran en
            un ambiente clásico y sofisticado. 🥃 Un entorno que te llevará de
            vuelta a una era de distinción y elegancia, donde el cuidado
            personal se combina con el disfrute real.
          </p>
        </div>

        {/* Vertical divider */}
        <div className="hidden md:block w-px bg-rotterdam-gold/30 mx-2 self-stretch" data-id="element-153" />

        {/* Salon photo */}
        <div className="flex-1 pl-0 md:pl-10 mt-10 md:mt-0" data-id="element-154">
          <img src="https://cdn.magicpatterns.com/uploads/henbapXBcZg25xT7Dv9yo5/salon.webp" alt="Salón Rotterdam Barbería" className="w-full h-full object-cover rounded-sm" style={{
          maxHeight: '420px'
        }} data-id="element-155" />
        </div>
      </motion.div>
    </section>;
}